import React from "react";

export const MYTHOS_URL = "https://mythosindiastudio.com/";
export const MYTHOS_CONTACT_URL = "https://mythosindiastudio.com/contact";
export const MYTHOS_CIN = "U62010TS2026PTC221089";

/**
 * Mythos India Studios — official brand mark.
 * Renders the parent-brand PNG logo. Optionally wraps in a link to the corporate site.
 */
export default function MythosLogo({ size = 40, className = "", linked = false, testid = "mythos-logo" }) {
  const img = (
    <img
      src="/mythos-logo.png"
      alt="Mythos India Studios Private Limited"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      data-testid={testid}
      loading="lazy"
    />
  );
  if (!linked) return img;
  return (
    <a
      href={MYTHOS_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Mythos India Studios (opens in new tab)"
      className="inline-flex items-center hover:opacity-80 transition"
      data-testid={`${testid}-link`}
    >
      {img}
    </a>
  );
}

export function MythosWordmark({ className = "", color = "#0E0F12", linked = false }) {
  const el = (
    <span
      className={`font-heading font-extrabold tracking-[0.16em] uppercase ${className}`}
      style={{ color, letterSpacing: "0.16em" }}
      data-testid="mythos-wordmark"
    >
      Mythos India Studios
    </span>
  );
  if (!linked) return el;
  return (
    <a href={MYTHOS_URL} target="_blank" rel="noopener noreferrer" data-testid="mythos-wordmark-link" className="hover:opacity-80 transition">
      {el}
    </a>
  );
}
